import { REHYDRATE } from 'redux-persist/lib/constants';
import { handleActions } from 'modules/helpers';

import { ActionTypes } from 'constants/index';

export const appState = {
  list: [],
  listForFilter: [],
  pages: 0,
  currentPage: 0,
  loading: false,
  item: null,
};

export default {
  accounts: handleActions(
    {
      [REHYDRATE]: draft => {
        draft.list = [];
      },
      [ActionTypes.GET_ACCOUNTS]: draft => {
        draft.loading = true;
      },
      [ActionTypes.GET_ACCOUNTS_SUCCESS]: (draft, { payload: { rows, pages, currentPage } }) => {
        draft.list = rows;
        draft.pages = pages;
        draft.currentPage = currentPage;
        draft.loading = false;
      },
      [ActionTypes.GET_ACCOUNTS_FAILURE]: draft => {
        draft.loading = false;
      },
      [ActionTypes.GET_ACCOUNT]: draft => {
        draft.item = null;
        draft.loading = true;
      },
      [ActionTypes.GET_ACCOUNT_SUCCESS]: (draft, { payload }) => {
        draft.item = payload;
        draft.loading = false;
      },
      [ActionTypes.GET_ACCOUNT_FAILURE]: draft => {
        draft.loading = false;
      },
      [ActionTypes.GET_ACCOUNTS_FOR_FILTER]: draft => {
        draft.loading = true;
      },
      [ActionTypes.GET_ACCOUNTS_FOR_FILTER_SUCCESS]: (draft, { payload }) => {
        draft.listForFilter = payload;
        draft.loading = false;
      },
      [ActionTypes.GET_ACCOUNTS_FOR_FILTER_FAILURE]: draft => {
        draft.loading = false;
      },
      [ActionTypes.CREATE_ACCOUNT]: draft => {
        draft.loading = true;
      },
      [ActionTypes.CREATE_ACCOUNT_RESOLVED]: draft => {
        draft.loading = false;
      },
      [ActionTypes.EDIT_ACCOUNT]: draft => {
        draft.loading = true;
      },
      [ActionTypes.EDIT_ACCOUNT_RESOLVED]: draft => {
        draft.loading = false;
      },
      [ActionTypes.DELETE_ACCOUNT]: draft => {
        draft.loading = true;
      },
      [ActionTypes.DELETE_ACCOUNT_SUCCESS]: (draft, { payload: { id } }) => {
        draft.list = draft.list.filter(item => item.id !== id);
        draft.loading = false;
      },
      [ActionTypes.DELETE_ACCOUNT_FAILURE]: (draft, { payload: { id } }) => {
        draft.loading = false;
      },
    },
    appState,
  ),
};
